<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <supplier-list
        v-bind:suppliers="supplierList"
        v-on:addSupplier="addSupplier"
        v-on:viewSupplier="viewSupplier"
        v-on:deleteSupplier="deleteSupplier"
      ></supplier-list>
    </div>
    <div class="md-layout-item md-size-50">
      <supplier-tabs
        v-bind:supplier="selectedSupplier"
        v-on:supplierUpdated="supplierUpdated"
      ></supplier-tabs>
    </div>
  </div>
</template>

<script>
import supplierApi from "@/services/api/supplier";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";
import _find from "lodash/find";
import _merge from "lodash/merge";

import SupplierList from "./SupplierList";
import SupplierTabs from "./SupplierTabs";

export default {
  components: {
    SupplierList,
    SupplierTabs
  },

  data() {
    return {
      selectedSupplier: null,
      supplierList: []
    };
  },

  methods: {
    getSuppliers() {
      supplierApi.getAll().then(response => {
        this.supplierList = response.data;
      });
    },

    addSupplier() {
      this.selectedSupplier = {};
    },

    viewSupplier(supplier) {
      this.selectedSupplier = { ...supplier };
    },

    deleteSupplier(supplier) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          supplierApi.delete(supplier.id).then(response => {
            this.supplierList = _filter(this.supplierList, function(item) {
              return item.id !== supplier.id;
            });
            this.selectedSupplier = null;
            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    supplierUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.viewSupplier(updateInfo.supplier);
        this.supplierList.unshift(updateInfo.supplier);
      } else {
        let supplier = _find(this.supplierList, ["id", updateInfo.supplier.id]);
        _merge(supplier, updateInfo.supplier);
      }
    }
  },

  mounted() {
    this.getSuppliers();
  }
};
</script>
